// ─────────────────────────────────────────────────────────────
// DATOS LEGALES — Titular: Alameda Software LTD (Reino Unido)
// ⚠️ La sociedad es británica (Companies House), pero el servicio se
//    dirige a clubes en España y trata datos de personas en la UE, por
//    lo que el RGPD aplica igualmente (art. 3 RGPD). Confirma con abogado
//    el encaje del Aviso Legal español y si necesitas nº de IVA/VAT.
// ─────────────────────────────────────────────────────────────
export const LEGAL = {
  nombreComercial: "ClubsAgent",
  dominio: "clubsagent.ai",
  webUrl: "https://clubsagent.ai",

  // Identidad del titular
  razonSocial: "Alameda Software LTD",
  paisRegistro: "Reino Unido",
  numeroSociedad: "16674259", // Company number (Companies House)
  vat: "", // Nº de IVA/VAT si aplica — COMPLETAR si tenéis

  // Domicilios
  domicilio: "3rd Floor, 86-90 Paul Street, London, EC2A 4NE, Reino Unido", // domicilio social registrado
  domicilioComercial: "28A High Street, London, N8 7NX, Reino Unido", // dirección comercial

  // Contacto
  email: "admin@clubsagent.ai",
  emailPrivacidad: "admin@clubsagent.ai",

  // Delegado de Protección de Datos (opcional; dejar "" si no hay)
  dpoEmail: "",

  // Encargados de tratamiento / proveedores (revisar y ajustar)
  encargados: [
    { nombre: "Amazon Web Services (AWS)", finalidad: "Alojamiento e infraestructura", ubicacion: "Unión Europea" },
    { nombre: "Stripe", finalidad: "Procesamiento de pagos y suscripciones", ubicacion: "UE / EE. UU. (cláusulas contractuales tipo)" },
    { nombre: "DeepSeek", finalidad: "Funciones de Asistente IA", ubicacion: "Ver tratamiento de datos de IA" },
  ],

  lastUpdated: "julio de 2026",
};
